import { HttpService } from '@/infra/http'
import type { TProfissao } from '@/types/cliente'

export class GetProfissoesService extends HttpService {
  async execute() {
    return this.http.get<TProfissao[]>('api/v2/Profissao/lista')
  }
}
